import { UI } from '@redux/model';
import { TypeLangs } from '@redux/reducer/localeReducer';
import { IconSecurity } from '@shares/DMPIcon';
import { Alert, Button, Col, Form, message, Row, Typography } from 'antd';
import { FormComponentProps } from 'antd/lib/form';
import { isEmpty } from 'lodash';
import { changeAntdTheme, generateThemeColor } from 'mini-dynamic-antd-theme';
import { TypeStatusUserWhenLoginSuccess, User } from 'o2o_layout/lib/common/model';
import queryString from 'query-string';
import { useEffect, useRef, useState } from 'react';
import { GoogleReCaptcha, GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import Helmet from 'react-helmet';
import { FormattedMessage } from 'react-intl';

import moment from 'moment';
import { typeGetMe, typeUpdateAuthen } from '../../common/actions/CommonAction';
import { BIGDATA_CONSTANT } from '../../common/constant';
import { cancelablePromise } from '../../common/helper';
import { UserDAL } from '../../dal/UserDAL';
import { LandingPage } from '../../layout/landing/LandingPage';
import logoOffical from '../../static/image/logo-pango.png';
import { typeUserLogin } from './actions/LoginAction';
import FormInputEmailAddress from './components/form/FormInputEmailAdress';
import FormInputPassword from './components/form/FormInputPassword';
import { ModalConfirm2FA } from './components/modal/ModalConfirm2FA';
import ModalForgotPassword from './components/modal/ModalForgotPassword';
import './login.scss';
import React from 'react';

interface LoginComponentV3Props extends FormComponentProps {
  getCurrentUser: any;
  ui: UI;
  setGlobalLoading: any;
  setMessage: any;
  locale: any;
  updateLocale: any;
  login: typeUserLogin;
  updateAuthen: typeUpdateAuthen;
  routing: any;
  history: any;
  logo: any;
  match: any;
  companyName: string;
  getMe: typeGetMe;
  user: User;
  userLogin2ft: any;
  location: Location;
  commonActionFromDALV2: any;
}

const LoginComponentV3 = Form.create<LoginComponentV3Props>()((props: LoginComponentV3Props) => {
  const [showModalTOTP, setShowModalTOTP] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [showMessage, setShowMessage] = useState<boolean>(false);
  const [visibleForgotPass, setVisibleForgotPass] = useState<boolean>(false);
  const [errorMsg, setErrorMsg] = useState<string>('');

  const [token, setToken] = useState<string>('');
  const [url, setUrl] = useState<string>('');
  const capchaRef = useRef<any>(null);

  useEffect(() => {
    handleUpdateLang();
    let query: any = queryString.parse(props.location.search);
    if (query && !isEmpty(query)) {
      let url: string = query.url;
      if (url) setUrl(url);
    }
    sessionStorage.setItem('isFirstLoggedIn', 'false');
    changeAntdTheme(generateThemeColor(BIGDATA_CONSTANT.primaryColor));
    const intervalID = setInterval(() => handleRecapchaloop(), 60 * 1000);

    return () => {
      pendingPromises.map((p: any) => p.cancel());
      clearInterval(intervalID);
    };
  }, []);

  const handleRecapchaloop = () => {
    if (!capchaRef?.current?.executeRecaptcha) return;
    const { executeRecaptcha } = capchaRef?.current;
    if (!executeRecaptcha) {
      console.log('Recaptcha has not been loaded');
      return;
    }
    executeRecaptcha('register').then((token: string) => {
      setToken(token);
    });
  };

  const handleFirstLogin = () => {
    sessionStorage.setItem('isFirstLoggedIn', 'true');
  };

  // const handleSuccessChangeLang = (key: string) => {
  //     let qString = props.location.search;
  //     const parseQuery = queryString.parse(qString)
  //     parseQuery.lang = key;
  //     qString = queryString.stringify(parseQuery);
  //     props.history.push({ pathname: props.location.pathname, search: qString })
  // }

  const handleUpdateLang = () => {
    let qString = props.location.search;
    const parseQuery = queryString.parse(qString);

    if (parseQuery.lang) {
      // debugger
      const lang: TypeLangs = parseQuery.lang == 'vi' || parseQuery.lang == 'en' ? parseQuery.lang : 'vi';
      props.updateLocale(lang);
    }
  };

  const handleShowOrHideAlert = () =>
    showMessage ? (
      <p style={{ color: '#DF052B', display: 'flex', alignItems: 'top', gap: 5 }}>
        <span style={{ marginTop: 1 }}>
          <IconSecurity />
        </span>
        <span>{errorMsg}</span>
      </p>
    ) : null;

  const handleStatus401 = () => {
    if (props.ui.errorStatus == 401) {
      // debugger
      if (props.match.path !== '/') {
        return (
          <Form.Item>
            <Alert message='Your session has expired' type='warning' showIcon />
          </Form.Item>
        );
      }
    }
    return null;
  };

  let pendingPromises: any[] = [];

  const handleAppendPendingPromise = (promise: any) => (pendingPromises = [...pendingPromises, promise]);

  const handleRemovePendingPromise = (promise: any) => (pendingPromises = pendingPromises.filter((p) => p !== promise));

  const handleSubmit = (e: any) => {
    e.preventDefault();
    props.form.validateFields(async (error: any, values: any) => {
      if (error) return;

      // const { executeRecaptcha } = capchaRef.current || {};
      // if (!executeRecaptcha) {
      //     console.warn("reCAPTCHA not loaded yet");
      //     return;
      // }

      // const token = await executeRecaptcha('register');
      if (!token) {
        setShowMessage(true);
        setErrorMsg('Capcha is required');
      }

      setToken(token); // lưu token mới (optional)
      setLoading(true);

      let ipData;
      let userAgent = window.navigator.userAgent;

      try {
        const ip = await props.commonActionFromDALV2(UserDAL.getIP);
        ipData = await ip;

      } catch (error) { }

      const wrappedPromise = cancelablePromise(
        props.login(values.userName, values.password, token, {
          'P-IP-ACCESS': ipData ? ipData.data || '' : '',
          'P-USR-AGENT': userAgent,
        })
      );

      handleAppendPendingPromise(wrappedPromise);

      wrappedPromise.promise
        .then((login: any) => {
          setLoading(false);
          setShowMessage(false);

          props.getMe().then(() => {
            if (login.success) {
              if (login.result.status == ('choose_org_ctx' as TypeStatusUserWhenLoginSuccess)) {
                handleFirstLogin();
                if (url) {
                  props.history.push({
                    pathname: '/companies/select',
                    search: queryString.stringify({
                      url,
                      lang: queryString.parse(props.location.search).lang,
                    }),
                  });
                } else {
                  props.history.push({
                    pathname: '/companies/select',
                    search: queryString.stringify({
                      target: 'my-account-info',
                      lang: queryString.parse(props.location.search).lang,
                    }),
                  });
                }
              } else if (login.result.status == ('authenticated' as TypeStatusUserWhenLoginSuccess)) {
                if (url) {
                  window.location.href = url;
                } else {
                  props.history.push({
                    pathname: '/dashboard',
                    search: queryString.stringify({
                      lang: queryString.parse(props.location.search).lang,
                    }),
                  });
                }
              } else if (login.result.status == ('totp_required' as TypeStatusUserWhenLoginSuccess)) {
                setShowModalTOTP(true);
              }
            } else if (!login.success && login.message === 'Your captcha is incorect') {
              setShowMessage(true);
              setErrorMsg(login.message);
              const { executeRecaptcha } = capchaRef.current;
              if (!executeRecaptcha) return;
              executeRecaptcha('register').then((token: string) => setToken(token));
            }
          });
        })
        .then(() => {
          handleRemovePendingPromise(wrappedPromise);
        })
        .catch((errorInfo) => {
          const { executeRecaptcha } = capchaRef.current;
          if (!executeRecaptcha) return;
          executeRecaptcha('register').then((token: string) => setToken(token));
          if (!errorInfo.isCanceled) {
            setLoading(false);
            setShowMessage(true);
            setErrorMsg(errorInfo.error.data.message);
          }
        });
    });
  };

  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={BIGDATA_CONSTANT.reCapchaSiteKey}
      language={props.locale}
      ref={(e: any) => (capchaRef.current = e)}
    >
      <LandingPage {...props} showHeader={false}>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              marginBottom: 28,
            }}
          >
            <img alt='logo' src={logoOffical} style={{ marginBottom: 14, width: 110, height: 110 }} />
            <p style={{ margin: 0, fontSize: 22, fontWeight: 700, color: '#3f3f46' }}> PangoCDP </p>
            <div style={{ marginTop: 5, fontSize: 13, color: '#90909a' }}>Enterprise Customer Data Platform</div>
          </div>

          <div>
            <Helmet>
              <title>My Account - ByteTech - Sign in Page</title>
              <meta name='description' content='My Account - ByteTech - Login Page' />
            </Helmet>

            {/* <DivIconByteTech /> */}

            <Form
              layout='vertical'
              autoComplete='off'
              onSubmit={handleSubmit}
              className='landing-form login-form-acc'
              colon={false}
              hideRequiredMark={true}
            >
              <Row type='flex' align='middle' gutter={[10, 10]}>
                <Col xs={24}>
                  <Form.Item>
                    <Typography.Title style={{ fontSize: 30, marginBottom: 10 }}>Sign in</Typography.Title>
                    <p style={{ fontSize: 16, lineHeight: '22px', color: '#87888C', opacity: '80%' }}>
                      Secure access to your PangoCDP workspace
                    </p>
                  </Form.Item>
                </Col>
                <Col xs={24}>
                  <FormInputEmailAddress form={props.form} />
                </Col>
                <Col xs={24}>
                  <FormInputPassword form={props.form} />
                </Col>
                <Col xs={24} style={{ display: 'flex', justifyContent: 'end', paddingTop: 4, paddingBottom: 15 }}>
                  <Button
                    type='link'
                    size='small'
                    style={{ padding: 0, textAlign: 'end' }}
                    onClick={() => {
                      setVisibleForgotPass(true);
                    }}
                  >
                    Forgot your password?
                  </Button>
                </Col>
                <Col xs={24}>
                  <Form.Item>
                    <Button htmlType='submit' type='primary' block icon='' loading={loading} disabled={!token}>
                      <FormattedMessage id='app.login.button.logins' defaultMessage='Sign In' />
                    </Button>
                  </Form.Item>
                </Col>

                <ModalForgotPassword
                  visible={visibleForgotPass}
                  hideModal={() => {
                    setVisibleForgotPass(false);
                  }}
                />
                <ModalConfirm2FA
                  hideModal={() => {
                    setShowModalTOTP(false);
                    const { executeRecaptcha } = capchaRef.current;
                    if (!executeRecaptcha) return;
                    executeRecaptcha('register').then((token: string) => setToken(token));
                  }}
                  loading={props.ui.isLoading}
                  okModal={(e: any, form: any) => {
                    if (e) e.preventDefault();
                    form.validateFields(async (err: any, values: any) => {
                      if (err) {
                        return;
                      }
                      props.setGlobalLoading(true);

                      props
                        .userLogin2ft(values.code, props.user.id)
                        .then((e: any) => {
                          props.setGlobalLoading(false);
                          if (e.success) {
                            if (e.result.status == 'choose_org_ctx') {
                              handleFirstLogin();
                              if (url) {
                                props.history.push({
                                  pathname: '/companies/select',
                                  search: queryString.stringify({
                                    url,
                                    lang: queryString.parse(props.location.search).lang,
                                  }),
                                });
                              } else {
                                props.history.push({
                                  pathname: '/companies/select',
                                  search: queryString.stringify({
                                    lang: queryString.parse(props.location.search).lang,
                                  }),
                                });
                              }
                            } else {
                              if (url) {
                                window.location.href = url;
                              } else {
                                props.history.push({
                                  pathname: '/dashboard',
                                  search: queryString.stringify({
                                    lang: queryString.parse(props.location.search).lang,
                                  }),
                                });
                              }
                            }
                          } else {
                            message.error(
                              e.message ? (
                                <span style={{ color: '#DC1F18' }}>{e.message}</span>
                              ) : (
                                <span style={{ color: '#DC1F18' }}>
                                  Incorrect authentication code. Please try again.
                                </span>
                              )
                            );
                          }
                        })
                        .catch(() => {
                          props.setGlobalLoading(false);
                          message.error(
                            <span style={{ color: '#DC1F18' }}>Incorrect authentication code. Please try again.</span>
                          );
                        });
                    });
                  }}
                  visible={showModalTOTP}
                />
              </Row>

              <GoogleReCaptcha action='register' onVerify={(token: any) => setToken(token)} />

              {handleStatus401()}

              {handleShowOrHideAlert()}

              <Form.Item style={{ marginTop: 10, textAlign: 'center' }}>
                <Typography.Text style={{ color: 'black' }}>
                  Don't have an account?{' '}
                  <Button
                    type='link'
                    size='small'
                    target='_blank'
                    href='https://pangocdp.com/vi/lien-he/'
                    style={{ paddingLeft: 1 }}
                  >
                    Contact us
                  </Button>
                </Typography.Text>
              </Form.Item>
            </Form>
          </div>

          <div style={{ marginTop: 50, marginBottom: 10, textAlign: 'center' }}>
            <Typography.Text>
              © 2016 - {moment().format('YYYY')}{' '}
              <Button
                type='link'
                size='small'
                target='_blank'
                href='https://www.bytetech.io/'
                style={{ padding: 0, opacity: '90%' }}
              >
                ByteTech
              </Button>
              . PangoCDP Platform. All rights reserved.
            </Typography.Text>
            <div
              style={{
                display: 'flex',
                flexWrap: 'wrap',
                alignItems: 'center',
                justifyContent: 'center',
                columnGap: 14,
              }}
            >
              <Button
                type='link'
                size='small'
                target='_blank'
                className='footer-link-btn'
                style={{ padding: 0, opacity: '90%' }}
                href='https://pangocdp.com/en/privacy-policy'
              >
                Privacy Policy
              </Button>
              <Button
                type='link'
                size='small'
                target='_blank'
                className='footer-link-btn'
                style={{ padding: 0, opacity: '90%' }}
                href='https://pangocdp.com/en/terms-of-service/'
              >
                Terms of Service
              </Button>
              <Button
                type='link'
                size='small'
                target='_blank'
                className='footer-link-btn'
                style={{ padding: 0, opacity: '90%' }}
                href='https://pangocdp.com/en/data-deletion/'
              >
                Data Deletion
              </Button>
            </div>
          </div>
        </div>
      </LandingPage>
    </GoogleReCaptchaProvider>
  );
});

export default LoginComponentV3;
